module.exports = __webpack_public_path__ + "img/inbox-02.4957edb0.svg";